import ApiHandler from "./ApiHandler";

const PersonalData = {
  putMyOne: async (data, options) => await ApiHandler.i.auth().put(`/personal-data`, data, options),
  putOne: async (userId, data, options) => await ApiHandler.i.auth().put(`/personal-data/${userId}`, data, options),
};

export default PersonalData;